import { render, staticRenderFns } from "./SwitchLiveBoxCustomer.vue?vue&type=template&id=10479fb0&"
import script from "./SwitchLiveBoxCustomer.vue?vue&type=script&lang=js&"
export * from "./SwitchLiveBoxCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLiveBoxCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10479fb0')) {
      api.createRecord('10479fb0', component.options)
    } else {
      api.reload('10479fb0', component.options)
    }
    module.hot.accept("./SwitchLiveBoxCustomer.vue?vue&type=template&id=10479fb0&", function () {
      api.rerender('10479fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/acquisition/vitrine/fragments/SwitchLiveBoxCustomer.vue"
export default component.exports